import { css, CSSResult } from 'lit'
import { csColorFunctional } from '@cloudsuite/mosaic-shared/styles/colors.style.js'


export const style: CSSResult = css`
  cse-form-field {
    display: block;
    width: 100%;
  }

  .search-options {
    overflow: auto;
    overscroll-behavior: none;
    max-height: var(--cse-popup-auto-size-available-height);
    display: flex;
    flex-direction: column;
    row-gap: var(--cse-dropdown-menu-gap);
  }
  
  cse-option > cse-icon {
    display: none;
  }
  
  cse-option:hover > cse-icon {
    display: block;
  }
  
  .icon-selected {
    color: ${csColorFunctional.info};
  }
  
  cse-button-input {
    cursor: text;
  }
`
